import { SyntheticEvent, memo, useCallback, useRef } from 'react'
import { clearAllPreviews } from '../../../app-state/modals/state.floater'
import { useFloatingPreviewSelector } from '../../Hooks/useModal'
import CameraButton from './Buttons/CameraButton'
import { setLargePreview } from './helpers'

interface LargeFloatingPreviewProps {
    id: number
    color?: string
    size?: number
    shadow?: boolean
    title?: string
}

const LargeFloatingPreview = memo((props: LargeFloatingPreviewProps) => {
    const { id, color, size, shadow, title } = props
    const previewPinned = useFloatingPreviewSelector(id, 'close')
    const previewId = useFloatingPreviewSelector(id, 'id')

    const isPreviewPlaying = !!previewId
    const isPreviewPinned = previewPinned && isPreviewPlaying
    const previewIcon = useRef<HTMLDivElement>(null)

    const onLargePreviewClickCallback = useCallback(
        (event: SyntheticEvent) => {
            event.stopPropagation()
            setLargePreview(
                id,
                previewIcon.current,
                !isPreviewPinned,
                !isPreviewPinned,
            )
        },
        [id, isPreviewPinned],
    )
    const onLargePreviewMouseEnterCallback = useCallback(
        (event: SyntheticEvent) => {
            event.stopPropagation()
            if (!isPreviewPinned) {
                clearAllPreviews()
                setLargePreview(id, previewIcon.current)
            }
        },
        [id, isPreviewPinned],
    )

    const onLargePreviewMouseLeaveCallback = useCallback(() => {
        if (!isPreviewPinned) {
            setLargePreview(id, null, false, false)
        }
    }, [id, isPreviewPinned])

    return (
        <div ref={previewIcon}>
            <CameraButton
                onMouseEnter={onLargePreviewMouseEnterCallback}
                onMouseLeave={onLargePreviewMouseLeaveCallback}
                onClick={onLargePreviewClickCallback}
                color={color}
                size={size}
                filled={isPreviewPinned}
                shadow={shadow}
                title={title}
            />
        </div>
    )
})

export default LargeFloatingPreview
